/**
 * Master Routes Configuration
 * 
 * Master 라우트 설정
 * - 경로와 컴포넌트를 분리하여 관리
 * - Lazy loading 적용으로 초기 번들 크기 감소
 */

import { lazy } from 'react';
import { RouteConfig } from './adminRoutes';

// Lazy load Master pages
const ClassCreate = lazy(() => import('../../pages/class/ClassCreate'));
const ClassManagement = lazy(() => import('../../pages/class/ClassManagement'));
const ClassDetail = lazy(() => import('../../pages/class/ClassDetail'));
const RedirectToMyClassDetail = lazy(() => import('../../pages/class/RedirectToMyClassDetail').then(m => ({ default: m.default })));
const MyClassList = lazy(() => import('../../pages/class/MyClassList'));
const ProductManagement = lazy(() => import('../../pages/product/ProductManagement'));
const ProductCreate = lazy(() => import('../../pages/product/ProductCreate'));
const ProductEdit = lazy(() => import('../../pages/product/ProductEdit'));
const ClassEdit = lazy(() => import('../../pages/class/ClassEdit'));
const OpenClassList = lazy(() => import('../../pages/class/OpenClassList'));
const MasterScenarioManagement = lazy(() => import('../../pages/scenario/MasterScenarioManagement'));
const ScenarioDetail = lazy(() => import('../../pages/scenario').then(m => ({ default: m.ScenarioDetail })));
const EventManagement = lazy(() => import('../../pages/assets/EventManagement'));
const EventCreate = lazy(() => import('../../pages/assets/EventCreate'));
const EventEdit = lazy(() => import('../../pages/assets/EventEdit'));
const AssetTaskManagement = lazy(() => import('../../pages/assets/AssetTaskManagement'));
const AssetActionManagement = lazy(() => import('../../pages/assets/AssetActionManagement'));
const DialogueManagement = lazy(() => import('../../pages/assets/DialogueManagement'));
const SymptomManagement = lazy(() => import('../../pages/assets/SymptomManagement'));
const Cart = lazy(() => import('../../pages/order/Cart'));
const Orders = lazy(() => import('../../pages/order/Orders'));
const OrderManagement = lazy(() => import('../../pages/order/OrderManagement'));
const OrderDetail = lazy(() => import('../../pages/order/OrderDetail'));

export const masterRoutes: RouteConfig[] = [
  {
    path: 'my-classes',
    component: MyClassList,
  },
  {
    path: 'my-classes/:id',
    component: ClassDetail,
  },
  {
    path: 'cart',
    component: Cart,
  },
  /** `/master/orders` — 마스터 개인 구매 내역(오픈클래스 등). GET `/order/my` (Orders 비임베드). 기관 주문 탭은 OrgPage `OrderManagement`. */
  {
    path: 'orders',
    component: Orders,
  },
  {
    path: 'order-management',
    component: OrderManagement,
  },
  {
    path: 'order-management/:orderId',
    component: OrderDetail,
  },
  {
    path: 'class-management',
    component: ClassManagement,
  },
  {
    path: 'class-management/:id',
    component: RedirectToMyClassDetail,
  },
  {
    path: 'product-management',
    component: ProductManagement,
  },
  {
    path: 'product/create',
    component: ProductCreate,
  },
  {
    path: 'open-class-list',
    component: OpenClassList,
  },
  {
    path: 'open-class/create',
    component: ClassCreate,
  },
  {
    path: 'open-class/:id',
    component: ClassDetail,
  },
  {
    path: 'product/edit/:id',
    component: ProductEdit,
  },
  {
    path: 'class/create',
    component: ClassCreate,
  },
  {
    path: 'class/duplicate/:id',
    component: ClassEdit,
  },
  {
    path: 'class/edit/:id',
    component: ClassEdit,
  },
  {
    path: 'scenarios',
    component: MasterScenarioManagement,
  },
  {
    path: 'scenarios/:id',
    component: ScenarioDetail,
  },
  {
    path: 'assets/events',
    component: EventManagement,
  },
  {
    path: 'assets/events/create',
    component: EventCreate,
  },
  {
    path: 'assets/events/:id/edit',
    component: EventEdit,
  },
  {
    path: 'assets/symptoms',
    component: SymptomManagement,
  },
  {
    path: 'assets/tasks',
    component: AssetTaskManagement,
  },
  {
    path: 'assets/actions',
    component: AssetActionManagement,
  },
  {
    path: 'assets/dialogues',
    component: DialogueManagement,
  },
  // /master/organization (관리자 설정)은 App.tsx에서 Full Screen으로 직접 라우팅됨 (OrgPage)
];
